import { Autocomplete, TextField } from "@mui/material";

import useDebouncedState from "~/shared/hooks/useDebouncedState";

import useEcologicalFunctionSelect_GetAutocompleteOptions from "./api/useEcologicalFunctionSelect_GetAutocompleteOptions";

type EcologicalFunctionSelectProps = {
    label: string;
    value?: string[] | null;
    onChange: (value: string[]) => void;
};

export default function EcologicalFunctionSelect({ label, value, onChange }: EcologicalFunctionSelectProps) {
    const [searchQuery, debouncedSearchQuery, setSearchQuery] = useDebouncedState("");

    const { options, selectedOptions, loading } = useEcologicalFunctionSelect_GetAutocompleteOptions({
        q: debouncedSearchQuery || undefined,
        selectedIds: value ?? undefined,
    });

    return (
        <Autocomplete
            multiple
            options={options}
            filterOptions={x => x}
            isOptionEqualToValue={(option, selected) => option.value === selected.value}
            loading={loading}
            getOptionKey={option => option.value}
            getOptionLabel={option => option.label}
            value={selectedOptions}
            onChange={(_, newValue) => onChange(newValue.map(x => x.value))}
            inputValue={searchQuery}
            onInputChange={(_, newInputValue, reason) => {
                if (reason === "reset") return;
                setSearchQuery(newInputValue);
            }}
            renderInput={params => <TextField {...params} fullWidth variant="outlined" label={label} />}
        />
    );
}
